import * as $ from "jquery";
import {EpMap} from "../../../map/map";
import {InventoryLocationsEditorContextMenu} from "../../../map/menu/InventoryLocationsEditorContextMenu";
import {fromLonLat} from "ol/proj";
import {confirmModal} from "../../../confirmModal";
import {inventoryLocationPoints} from "./points";
import {EpInventoryLocations} from "../../../map/layers/inventory-locations";
import {InventoryLocationInteractionsHandler} from "./interactions";
import {EpLayer} from "../../../map/layers/layer";
import {farInventoryTrackedRouteStyle, inventoryTrackedRouteStyle} from "../../../map/styles/inventory-tracked-routes";
import {closeModal, openModal} from "../../../utilities";

export const locationsManagementPage = () => {
    let inventoryLocationsMapContainer = $('.inventory-locations-map');
    inventoryLocationsMapContainer.height($(document).height() - 116);
    const target = inventoryLocationsMapContainer.attr('id');

    // const interactionsContainer = $('#inventoryInteractionsContainer');
    // interactionsContainer.css({maxHeight: $(document).height() - 116});

    const body = $('body');

    // Prevent from submitting with "enter" keyboard
    $(window).keydown(function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    const form = body.find('#addLocation, #editLocation');

    /// Setup map
    let epMap = new EpMap({target, ruler: true});
    epMap.contextMenu = new InventoryLocationsEditorContextMenu();

    // Setup locations layer
    let locationsLayer = null;
    if (typeof window._locations != 'undefined') {
        let locations = JSON.parse(window._locations);

        if (/edit\/locations.*?\/(edit)/.test(window.location.href)) {
            let match = window.location.href.match(/edit\/locations\/(.*?)\/(edit)/);
            locations = locations.filter(location => parseInt(location.id) !== parseInt(match[1]));
        }

        // locations layer
        locationsLayer = new EpInventoryLocations(epMap.map);
        epMap.changeStyleUnderZoom(locationsLayer)

        for (let location of locations) {
            locationsLayer.addFeature(location.coordinates, {
                fields: {
                    name: location.name
                }
            });
        }

        epMap.addCustomLayer(locationsLayer);
    }

    // Setup boundaries layer
    epMap.addBoundariesLayer();
    if (typeof window._boundaries != 'undefined') {
        let boundaries = JSON.parse(window._boundaries);
        $('[name="district_id"]').change(function() {
            epMap.boundaries.getSource().clear();
            const id = parseInt($(this).val());

            const el = boundaries.find(b => parseInt(b.district_id) === id);
            if(el && el.coordinates) {
                epMap.boundaries.addFeature(el.coordinates);
                epMap.boundaries.fitInView();
            }
        }).change()
    }

    // Setup sectors layer
    epMap.addSectorsLayer();
    if (typeof window._sectors != 'undefined') {
        epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
    }

    // Setup tracked routes
    if (typeof window._tracked_routes != 'undefined') {
        let trackedRoutes = JSON.parse(window._tracked_routes);

        // locations layer
        let trackedRoutesLayer = new EpLayer(epMap.map);
        trackedRoutesLayer.setStyle(inventoryTrackedRouteStyle, farInventoryTrackedRouteStyle);
        trackedRoutesLayer.name = 'tracked_routes';
        trackedRoutesLayer.title = 'Ścieżki';

        epMap.changeStyleUnderZoom(trackedRoutesLayer)

        for (let trackedRoute of trackedRoutes) {
            trackedRoutesLayer.addFeature(trackedRoute.coordinates, {type: 'LineString'});
        }

        epMap.addCustomLayer(trackedRoutesLayer);
    }

    const coordinatesInput = form.find('[name="coordinates"]')

    let interactionsHandler = new InventoryLocationInteractionsHandler(epMap);

    window._interactionsHandler = interactionsHandler;

    $('#btnGenerateBasedOnDistrict').click(async function () {
        let feature = interactionsHandler
            .interactions
            .location
            .features[0] ?? null;



        const boundaries = JSON.parse(window._boundaries);
        const el = boundaries.find(b => parseInt(b.district_id) === parseInt($('[name="district_id"]').val()));
        if(!el || !el.coordinates) {
            return;
        }

        if (!feature) {
            coordinatesInput.val(el.coordinates);

            interactionsHandler.interactions.location.createFeatureFromInput();
            interactionsHandler.interactions.location.updateAreaInfo();

            return;
        }

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz zmienić granicę obszaru?');
        if (!confirm) return;

        let points = el.coordinates.split(' ')
        let coordinatesArray = [points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")))];
        feature.getGeometry().setCoordinates(coordinatesArray);

        interactionsHandler.interactions.location.updateFeature(feature);
        interactionsHandler.interactions.location.updateAreaInfo();
    })

    // enable interaction
    if(parseInt(window._inventory_type) !== 5) {
        interactionsHandler.interactions.location.setEnabled(true);
    }

    if(parseInt(window._inventory_type) === 2) {
        interactionsHandler.interactions.observers_line.setEnabled(true);
    }

    if([2, 3].includes(parseInt(window._inventory_type))) {
        interactionsHandler.interactions.beaters_line.setEnabled(true);
    }

    // handle thermal-imaging-type change
    if(parseInt(window._inventory_type) === 5) {
        interactionsHandler.interactions.thermal_imaging_areas.setEnabled(true);
        interactionsHandler.interactions.thermal_imaging_routes.setEnabled(true);
        interactionsHandler.interactions.thermal_imaging_transects.setEnabled(true);

        interactionsHandler.interactions.thermal_imaging_areas.show();
        interactionsHandler.interactions.thermal_imaging_routes.show();
        interactionsHandler.interactions.thermal_imaging_transects.show();

        $('[data-app-information_name="transects_length"]').show();
        $('[data-app-information_name="transects_area"]').show();
        $('[data-app-information_name="areas_area"]').show();

        form.submit(function(e) {
            e.preventDefault();

            const geometryFeatures = interactionsHandler.interactions.thermal_imaging_transects.geometryFeatures;
            const json = encodeURIComponent(JSON.stringify(geometryFeatures));

            form.append(`<input type="hidden" name="geometry_features" value="${json}" />`)

            this.submit();
        })
    }

    inventoryLocationPoints(epMap);

    $('input[name="zone_depth"]').change(function() {
        if($('#custom_zone_depth').is(':checked')) {
            $("#custom_zone_depth_input").attr('disabled', false)
        } else {
            $("#custom_zone_depth_input").attr('disabled', true)
        }
    }).change()

    let editAreaTypeFeatureId = null;
    let editAreaInteractionObject = null;
    body.on('click', '.btnEditAreaType', function() {
        $('.error[data-for="edit_area_type"]').text('');

        editAreaTypeFeatureId = $(this).data('app-feature_id');
        const type = parseInt($(this).data('app-area_type'));

        const select = $('#editAreaTypeModal select[name="edit_area_type"]');
        select.val(type)

        if($(this).data('app-map_interaction_area_type') === 'thermal_imaging_areas') {
            editAreaInteractionObject = interactionsHandler.interactions.thermal_imaging_areas;
        } else {
            editAreaInteractionObject = interactionsHandler.interactions.thermal_imaging_transects;
        }

        openModal('#editAreaTypeModal');
    })

    body.on('click', '#btnEditAreaTypeEdit', function() {
        const select = $('#editAreaTypeModal select[name="edit_area_type"]');
        const selected = parseInt(select.val());

        // update text
        $(`[data-app-map_interaction_area_type][data-app-feature_id="${editAreaTypeFeatureId}"]`)
            .text(selected === 2 ? 'polny' : 'leśny')
            .data('app-area_type', selected)

        // update input
        $(`[name="thermal_imaging_area_types[${editAreaTypeFeatureId}]"][data-app-map_interaction_input="thermal_imaging_area_types"]`)
            .val(selected);

        // update feature
        if(editAreaInteractionObject) {
            let feature = editAreaInteractionObject.features.find(feature => feature.get('id') == editAreaTypeFeatureId);
            if(feature) {
                feature.set('area_type', selected);
            }

            editAreaInteractionObject.updateAreaInfo();
        }

        closeModal('#editAreaTypeModal')
    })

    $('[name="district_id"]').change(function() {
        $('[name="hidden_district_id"]').val($(this).val())
    }).change();
}